export const currencyOptions = [
  /* { value: "USD", label: "Доллары · $" }, */
  { value: 'RUB', label: 'Рубли · ₽' },
  { value: 'KZT', label: 'Тенге · ₸' },
  { value: 'USD', label: 'Доллар · $' },
];
